"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORWARD_MESSAGE_SUBJECT_PREFIX = exports.MIN_TOAST_LIFETIME = exports.MAX_TOAST_LIFETIME = exports.WORKGROUP_RESTRICTION = exports.UPLOAD_ADD_FAIL = exports.SITEWIDE_WARNING = exports.LOGIN_ERROR_TOAST_ID = exports.INTERCEPTED_UNKNOWN_ERROR = exports.INTERCEPTED_INTERNAL_SERVER_ERROR = exports.INTERCEPTED_BAD_REQUEST = exports.GATEWAY_DOWNLOAD_LIMIT_WARNING = exports.HOME_PATH = exports.DAYS_IN_SECS = exports.DATE_FORMAT = exports.DATE_TIME_FORMAT = exports.REFRESH_PACKAGE_CACHE_INTERVAL = exports.ACTIVITY_OFFSET = exports.SESSION_TIME_COUNTDOWN = exports.SESSION_TIME_REMAINING = exports.PERIODICITY = exports.NOT_APPLICABLE = exports.ASPERA_SDK_V4_LOCATION = exports.ASPERA_SDK_LOCATION = exports.ASPERA_PLUGIN_RECOMMENDED_VERSION = exports.ASPERA_PLUGIN_MIN_VERSION = exports.DEFAULT_CONNECT_DOWNLOAD_URL = exports.INTERNAL_CONNECT_MAC_DOWNLOAD_URL = exports.INTERNAL_CONNECT_WINDOWS_DOWNLOAD_URL = exports.BLAST_INACTIVITY_TIMEOUT_SECS = exports.LOGOUT_TRIGGER_KEY = exports.JWT_STORAGE_KEY = exports.BLAST_WORKGROUPS_KEY = exports.BLAST_USERS_KEY = exports.BLAST_REMEMBER_USER_KEY = exports.BLAST_LOGIN = exports.BLAST_INTERACTIONS_KEY = exports.BLAST_ENV = exports.BLAST_ACTIVITY = exports.ASPERA_CONNECT_APP_ID = exports.ASPERA_BANNER_TIMEOUT_KEY = exports.KEY_TAB_VALUE = exports.KEY_TAB = exports.KEY_SEMICOLON_VALUE = exports.KEY_SEMICOLON = exports.KEY_ESCAPE_VALUE = exports.KEY_ESCAPE = exports.KEY_ENTER_VALUE = exports.KEY_ENTER = exports.KEY_COMMA_VALUE = exports.KEY_COMMA = void 0;
exports.PRIORITIZED_EMAILS = exports.EMAIL_MISMATCH = exports.HTTP_GATEWAY_ENDPOINT = exports.GATEWAY_DOWNLOAD_TIMEOUT = exports.ACTIVE_GATEWAY_DOWNLOAD_LIMIT = exports.TRANSFER_STATUS_NOT_STARTED = exports.REMOTE_SOURCE_FILES_REQUEST_SIZE = exports.RECIPIENTS_LIST_CHARACTER_LIMIT = void 0;
// Blast Imports
var utils_1 = require("@app/shared/utils");
// Keyboard values
exports.KEY_COMMA = 44;
exports.KEY_COMMA_VALUE = ',';
exports.KEY_ENTER = 13;
exports.KEY_ENTER_VALUE = 'Enter';
exports.KEY_ESCAPE = 27;
exports.KEY_ESCAPE_VALUE = 'Escape';
exports.KEY_SEMICOLON = 59;
exports.KEY_SEMICOLON_VALUE = ';';
exports.KEY_TAB = 9;
exports.KEY_TAB_VALUE = 'Tab';
// Storage keys
exports.ASPERA_BANNER_TIMEOUT_KEY = 'hsb-aspera-banner-expiration';
exports.ASPERA_CONNECT_APP_ID = 'connect-app-id';
exports.BLAST_ACTIVITY = 'hsb-blast-active';
exports.BLAST_ENV = 'hsb-blast-env';
exports.BLAST_INTERACTIONS_KEY = 'hsb-blast-interactions';
exports.BLAST_LOGIN = 'hsb-blast-login';
exports.BLAST_REMEMBER_USER_KEY = 'hsb-blast-remember-user';
exports.BLAST_USERS_KEY = 'hsb-blast-users';
exports.BLAST_WORKGROUPS_KEY = 'hsb-blast-workgroups';
exports.JWT_STORAGE_KEY = 'hsb-blast-jwt';
exports.LOGOUT_TRIGGER_KEY = 'hsb-logout';
exports.BLAST_INACTIVITY_TIMEOUT_SECS = 'hsb-blast-timeout-secs';
exports.INTERNAL_CONNECT_WINDOWS_DOWNLOAD_URL = 'softwarecenter:SoftwareID=ScopeId_99B012E0-6507-4062-B498-720B4605DDBC/Application_ea1004a3-6fb3-4959-be6d-88d2d53b7e1f';
exports.INTERNAL_CONNECT_MAC_DOWNLOAD_URL = 'jamfselfservice://content?entity=policy&id=2076&action=execute';
exports.DEFAULT_CONNECT_DOWNLOAD_URL = 'https://test-connect.ibmaspera.com/';
exports.ASPERA_PLUGIN_MIN_VERSION = '4.0.0';
exports.ASPERA_PLUGIN_RECOMMENDED_VERSION = '4.2.5';
exports.ASPERA_SDK_LOCATION = '//d3gcli72yxqn2z.cloudfront.net/@ibm-aspera/connect-sdk-js/v5.0.3/';
exports.ASPERA_SDK_V4_LOCATION = 'https://d3gcli72yxqn2z.cloudfront.net/connect_3_11_1_03a7a5d_ga/v4/'; // TODO: Delete post v5 upgrade
exports.NOT_APPLICABLE = 'N/A';
/** Inactivity related constants */
exports.PERIODICITY = 60E3; // 1 minute
/**
 * Remaining time before session becomes inactive
 *  SESSION_TIME_REMAINING: Number of minutes left in session needed to trigger Inactivity Modal
 *  SESSION_TIME_COUNTDOWN: Countdown (in seconds) displayed in the Inactivity Modal
 *  ACTIVITY_OFFSET: Number of minutes to offset the calculation of last activity. Without this, the user will be in a constant loop of refreshing.
 */
exports.SESSION_TIME_REMAINING = 2; // 2 minutes
exports.SESSION_TIME_COUNTDOWN = (exports.SESSION_TIME_REMAINING) * 60; // 120 seconds
exports.ACTIVITY_OFFSET = 60; // seconds
exports.REFRESH_PACKAGE_CACHE_INTERVAL = 5 * exports.PERIODICITY; // 5 mins
exports.DATE_TIME_FORMAT = 'DD-MMM-YYYY hh:mmA';
exports.DATE_FORMAT = 'DD-MMM-YYYY';
exports.DAYS_IN_SECS = (24 * 60 * 60);
exports.HOME_PATH = '/dash';
/* Toast IDs */
exports.GATEWAY_DOWNLOAD_LIMIT_WARNING = 'GATEWAY_DOWNLOAD_LIMIT';
exports.INTERCEPTED_BAD_REQUEST = 'INTERCEPTED_BAD_REQUEST';
exports.INTERCEPTED_INTERNAL_SERVER_ERROR = 'INTERCEPTED_INTERNAL_SERVER_ERROR';
exports.INTERCEPTED_UNKNOWN_ERROR = 'INTERCEPTED_UNKNOWN_ERROR';
exports.LOGIN_ERROR_TOAST_ID = 'LOGIN_ERROR';
exports.SITEWIDE_WARNING = 'SITEWIDE_WARNING';
exports.UPLOAD_ADD_FAIL = 'UPLOAD_ADD_FAIL';
exports.WORKGROUP_RESTRICTION = 'WORKGROUP_RESTRICTION';
// Custom Toast (components/controls/Toast)
exports.MAX_TOAST_LIFETIME = 7000; // in ms
exports.MIN_TOAST_LIFETIME = 2000; // in ms
/* Upload Form constants */
exports.FORWARD_MESSAGE_SUBJECT_PREFIX = 'FW:';
exports.RECIPIENTS_LIST_CHARACTER_LIMIT = 1200;
exports.REMOTE_SOURCE_FILES_REQUEST_SIZE = 100;
/* Transfer Status constants */
exports.TRANSFER_STATUS_NOT_STARTED = 'Not Started';
/* Http Gateway */
exports.ACTIVE_GATEWAY_DOWNLOAD_LIMIT = 3;
exports.GATEWAY_DOWNLOAD_TIMEOUT = (10 * 1000); // in ms
exports.HTTP_GATEWAY_ENDPOINT = '/aspera/http-gwy/v1';
/* Error page types */
exports.EMAIL_MISMATCH = 'email_mismatch';
/* Prioritized emails */
exports.PRIORITIZED_EMAILS = [
    utils_1.normalize('MTGHiResFinals@wizards.com'),
    utils_1.normalize('RPLab@hasbro.com'),
    utils_1.normalize('pubassets@hasbro.com'),
    utils_1.normalize('jetpackfileexchange@hasbro.com'),
    utils_1.normalize('Global_Translations_MML@hasbro.com'),
    utils_1.normalize('newdndart@wizards.com'),
    utils_1.normalize('digitalassetmanagement@hasbro.com'),
    utils_1.normalize('AHsubmissions@hasbro.com'),
    utils_1.normalize('copyctr-newportave@hasbro.com'),
    utils_1.normalize('ExpressionCreativeDev@hasbro.com'),
    utils_1.normalize('SportsAction_CreativeDev@Hasbro.com'),
    utils_1.normalize('CSSWatermarkDelivery@Hasbro.com'),
    utils_1.normalize('digitalcontent@hasbro.com'),
    utils_1.normalize('GamesSubmissions@Hasbro.com'),
    utils_1.normalize('GMC_Assets@hasbro.com'),
    utils_1.normalize('GMC_ECAssets@hasbro.com'),
    utils_1.normalize('SPLHiResFinals@wizards.com'),
    utils_1.normalize('andrew.willis@hasbro.com')
];
